import React, {useEffect} from 'react'
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  TextField,
  FormHelperText,
} from '@material-ui/core'
import moment from 'moment'
export default function WDateField({data, onChange}) {
  useEffect(() => {
    if (data?.default_value?.value) {
      if (data.default_value.value === 'date_today') {
        let e = {
          target: {
            value: moment()
              .local()
              .format('YYYY-MM-DD'),
          },
        }
        if (data.default_value.op === 'add') {
          e.target.value = moment()
            .clone()
            .add(data.default_value.days, 'days')
            .add(data.default_value.months, 'months')
            .add(data.default_value.years, 'years')
            .local()
            .format('YYYY-MM-DD')
        } else if (data.default_value.op === 'subtract') {
          e.target.value = moment()
            .clone()
            .subtract(data.default_value.days, 'days')
            .subtract(data.default_value.months, 'months')
            .subtract(data.default_value.years, 'years')
            .local()
            .format('YYYY-MM-DD')
        }
        onChange(e, 'value', data)
      }
    }
    return () => {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  return (
    <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
      <TextField
        id="outlined-adornment-amount"
        value={data.value}
        onChange={e => {
          onChange(e, 'value', data)
        }}
        type={'date'}
        labelWidth={60}
        label={data.name}
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
      />
      <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
    </FormControl>
  )
}
